import { createMigrate, createTransform } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import { ICreateSendContentsState } from '../../types/createSendContents';
import { ICreateSendCrmState } from '../../types/createSendCrm';
import { ICreateSendRecipientsState } from '../../types/createSendRecipients';
import { createSendMigrations, CREATE_SEND_PERSIST_VERSION } from './migrations';
import { normalizePersistedContents } from './persistedContents';
import { normalizePersistedCrm } from './persistedCrm';
import { normalizePersistedRecipients } from './persistedRecipients';

export const RECIPIENTS_PERSISTED_KEYS: (keyof ICreateSendRecipientsState)[] = [
  'addressMode',
  'claimLinkMode',
  'multiKitAddressMode',
  'selectedClaimAddressIds',
  'overrideAddress',
  'oneTimeAddress',
  'recipients',
];

export const recipientsTransform = createTransform<ICreateSendRecipientsState, Partial<ICreateSendRecipientsState>>(
  (inbound) => ({
    ...RECIPIENTS_PERSISTED_KEYS.reduce<Partial<ICreateSendRecipientsState>>(
      (acc, key) => ({ ...acc, [key]: inbound[key] }),
      {},
    ),
    recipients: normalizePersistedRecipients(inbound.recipients),
  }),
  (outbound) =>
    ({
      ...outbound,
      recipients: normalizePersistedRecipients(outbound.recipients),
    } as ICreateSendRecipientsState),
  { whitelist: ['recipients'] },
);

export const crmTransform = createTransform<ICreateSendCrmState, Partial<ICreateSendCrmState>>(
  (inbound) => ({ byRecipientUid: inbound.byRecipientUid, shipment: inbound.shipment }),
  normalizePersistedCrm,
  { whitelist: ['crm'] },
);

export const contentsTransform = createTransform<ICreateSendContentsState, Partial<ICreateSendContentsState>>(
  (inbound) => inbound,
  normalizePersistedContents,
  { whitelist: ['contents'] },
);

export const createSendPersistConfig = {
  key: 'createSend',
  version: CREATE_SEND_PERSIST_VERSION,
  storage,
  whitelist: [
    'method',
    'contents',
    'recipients',
    'shipmentInfo',
    'customMessage',
    'sendSettings',
    'linkSettings',
    'claimPage',
    'email',
    'crm',
  ],
  transforms: [recipientsTransform, crmTransform, contentsTransform],
  migrate: createMigrate(createSendMigrations, { debug: false }),
  stateReconciler: autoMergeLevel2,
};
